var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { createSimpleThemedComponent } from '../util/createThemedComponent';
var InnerSelect = function (_a) {
    var items = _a.items, placeholder = _a.placeholder, children = _a.children, props = __rest(_a, ["items", "placeholder", "children"]);
    return (jsx("select", __assign({}, props),
        placeholder && (jsx("option", { value: "", disabled: true, selected: true }, placeholder)),
        items &&
            items.map(function (_a) {
                var value = _a.value, text = _a.text;
                return (jsx("option", { key: value, value: value }, text));
            }),
        children));
};
export var SelectField = createSimpleThemedComponent({
    as: InnerSelect,
    variant: 'default',
    themeKey: 'selects',
    sx: {
        fontSize: 2,
        color: 'text',
        outline: 'none',
        appearance: 'none',
    },
});
//# sourceMappingURL=SelectField.js.map